import { Step, StepLabel, Stepper } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useWizard } from 'react-use-wizard';
import { AodRuleSteps } from './steps/AodRuleSteps';

export function WizardHeader({ steps }: { steps: AodRuleSteps }) {
  const { activeStep } = useWizard();

  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((step) => (
        <Step
          key={step.id}
          sx={{
            '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel': {
              color: 'grey.500',
            },
            '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel': {
              fontSize: 'normal',
            },
          }}
        >
          <StepLabel>
            <FormattedMessage {...step.labelMessage} />
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
